document.addEventListener('DOMContentLoaded', function() {
  // Initialize mobile swiper
  initMobileSwiper();
  
  // Initialize buy option selection with a small delay to ensure DOM is ready
  setTimeout(() => {
    initBuyOptionSelection();
  }, 100);
  
  // Initialize modal functionality
  initModalFunctionality();
  
  // Initialize collapsible functionality
  initCollapsibleFunctionality();
  
  // Initialize timers
  initTimers();
});

function initMobileSwiper() {
  const mobileGallery = document.querySelector('.mobile-gallery-swiper');
  if (!mobileGallery) return;

  // Initialize Swiper with optimized settings
  const swiper = new Swiper(mobileGallery, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    loopAdditionalSlides: 2,
    grabCursor: true,
    allowTouchMove: true,
    speed: 400,
    effect: 'slide',
    width: null,
    // Remove autoplay completely
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: mobileGallery.querySelector('.swiper-pagination'),
      clickable: true,
      type: 'bullets',
    },
    // Optimized transitions
    on: {
      init: function() {
        mobileGallery.classList.add('swiper-initialized');
        this.el.style.opacity = '1';
        this.el.style.transform = 'translateY(0)';
        
        // Force correct width calculation
        this.updateSize();
        this.updateSlidesClasses();
        
        // Ensure first slide is properly loaded
        setTimeout(() => {
          this.update();
        }, 100);
      },
      slideChange: function() {
        // Simplified transition effects
        const activeSlide = this.slides[this.activeIndex];
        if (activeSlide) {
          activeSlide.style.transform = 'scale(1.01)';
          setTimeout(() => {
            activeSlide.style.transform = 'scale(1)';
          }, 200);
        }
      },
      touchStart: function() {
        mobileGallery.classList.add('swiper-touch');
      },
      touchEnd: function() {
        mobileGallery.classList.remove('swiper-touch');
      },
      resize: function() {
        // Handle resize properly
        this.updateSize();
        this.updateSlidesClasses();
      }
    }
  });

  // Add smooth hover effects to navigation buttons
  const navButtons = mobileGallery.querySelectorAll('.swiper-button-next, .swiper-button-prev');
  navButtons.forEach(button => {
    button.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-50%) scale(1.1)';
      this.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(-50%) scale(1)';
    });
  });

  // Add smooth slide transitions
  const slides = mobileGallery.querySelectorAll('.swiper-slide');
  slides.forEach(slide => {
    slide.style.transition = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
  });

  // Add touch feedback
  mobileGallery.addEventListener('touchstart', function() {
    this.classList.add('swiper-touch');
  });

  mobileGallery.addEventListener('touchend', function() {
    setTimeout(() => {
      this.classList.remove('swiper-touch');
    }, 300);
  });
}


function initBuyOptionSelection() {
  const buyOptions = document.querySelectorAll('.landing-featured-product__buy-option');
  const addToCartForm = document.querySelector('.product-form');
  const quantityInput = addToCartForm ? addToCartForm.querySelector('input[name="quantity"]') : null;
  const addToCartButton = document.querySelector('.add-to-cart-btn');
  
  if (!buyOptions.length) return;
  
  // Calculate and display prices for all options
  buyOptions.forEach(option => {
    calculateAndDisplayPrices(option);
  });
  
  // Select first option by default
  if (buyOptions.length > 0) {
    buyOptions[0].classList.add('selected');
    updateAddToCartButton(buyOptions[0]);
  }
  
  buyOptions.forEach(option => {
    option.addEventListener('click', function() {
      // Remove selected class from all options
      buyOptions.forEach(opt => opt.classList.remove('selected'));
      
      // Add selected class to clicked option
      this.classList.add('selected');
      
      // Update add to cart button
      updateAddToCartButton(this);
    });
  });
  
  function calculateAndDisplayPrices(option) {
    const basePrice = parseFloat(option.dataset.originalPrice) || 0;
    const quantity = parseInt(option.dataset.quantity) || 1;
    const displayMultiplier = parseInt(option.dataset.displayMultiplier) || quantity;
    const discountPercentage = parseFloat(option.dataset.discountPercentage) || 0;
    const manualComparePrice = parseFloat(option.dataset.manualComparePrice) || 0;
    const manualCurrentPrice = parseFloat(option.dataset.manualCurrentPrice) || 0;
    
    let targetOriginalPrice, targetDiscountedPrice;
    
    // Check if manual prices are set
    if (manualComparePrice > 0 && manualCurrentPrice > 0) {
      // Use manual prices
      targetOriginalPrice = manualComparePrice;
      targetDiscountedPrice = manualCurrentPrice;
    } else {
      // Use calculated prices based on discount percentage
      const discountAmount = basePrice * (discountPercentage / 100);
      const discountedPricePerUnit = basePrice - discountAmount;
      targetDiscountedPrice = discountedPricePerUnit * quantity;
      targetOriginalPrice = basePrice * quantity;
    }
    
    // Use exact prices without rounding - convert to string to avoid floating point issues
    const totalPriceRounded = targetDiscountedPrice;
    const originalTotalRounded = targetOriginalPrice;
    
    // Update price display
    const priceDisplay = option.querySelector('.landing-featured-product__buy-option-content-price span:first-child');
    const priceOld = option.querySelector('.landing-featured-product__buy-option-content-price-old');
    const priceDiscountText = option.querySelector('.landing-featured-product__buy-option-content-price-text');
    
    if (priceDisplay) {
      // Format price to avoid floating point precision issues
      const formattedPrice = (Math.round(totalPriceRounded * 100) / 100).toFixed(2);
      priceDisplay.textContent = `$${formattedPrice}`;
    }
    
    if (priceOld && originalTotalRounded > totalPriceRounded) {
      // Format price to avoid floating point precision issues
      const formattedOldPrice = (Math.round(originalTotalRounded * 100) / 100).toFixed(2);
      priceOld.textContent = `$${formattedOldPrice}`;
      priceOld.style.display = 'inline';
    }
    
    if (priceDiscountText && discountPercentage > 0) {
      // Use the discount percentage from admin settings
      priceDiscountText.textContent = `${discountPercentage}% off`;
      priceDiscountText.style.display = 'inline';
    }
  }
  
  function updateAddToCartButton(selectedOption) {
    if (!addToCartButton || !selectedOption) return;
    
    const optionId = selectedOption.dataset.optionId;
    const actualQuantity = selectedOption.dataset.quantity;
    const titleElement = selectedOption.querySelector('.landing-featured-product__buy-option-content-title');
    const priceElement = selectedOption.querySelector('.landing-featured-product__buy-option-content-price span:first-child');
    const oldPriceElement = selectedOption.querySelector('.landing-featured-product__buy-option-content-price-old');
    
    if (!titleElement || !priceElement) return;
    
    const priceMatch = priceElement.textContent.match(/\$([\d.]+)/);
    const oldPriceMatch = oldPriceElement ? oldPriceElement.textContent.match(/\$([\d.]+)/) : null;
    
    if (!priceMatch) return;
    
    const quantity = actualQuantity || 1;
    const price = priceMatch[1];
    const oldPrice = oldPriceMatch ? oldPriceMatch[1] : null;
    
    // Update quantity input
    if (quantityInput) {
      quantityInput.value = quantity;
    }
    
    // Update button text
    const buttonText = addToCartButton.querySelector('.button-text-price');
    if (buttonText) {
      const mainText = buttonText.textContent.split(' - ')[0];
      const stockText = buttonText.querySelector('p') ? buttonText.querySelector('p').textContent : '';
      
      if (oldPrice) {
        // Show both compare price and current price
        buttonText.innerHTML = `${mainText} - <span class="landing-featured-product__buy-option-content-price-old">$${oldPrice}</span> $${price}<p>${stockText}</p>`;
      } else {
        // Show only current price
        buttonText.innerHTML = `${mainText} - $${price}<p>${stockText}</p>`;
      }
    }
    
    // Update form action to include selected option
    if (addToCartForm) {
      // You might want to add a hidden input for the selected option
      let optionInput = addToCartForm.querySelector('input[name="selected_option"]');
      if (!optionInput) {
        optionInput = document.createElement('input');
        optionInput.type = 'hidden';
        optionInput.name = 'selected_option';
        addToCartForm.appendChild(optionInput);
      }
      optionInput.value = optionId;
    }
  }
}

function initModalFunctionality() {
  const modalTriggers = document.querySelectorAll('.modal-trigger');
  const modals = document.querySelectorAll('.custom-modal');
  
  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const modalId = this.dataset.modalId;
      const modal = document.getElementById(modalId);
      
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
  });
  
  modals.forEach(modal => {
    const closeBtn = modal.querySelector('.custom-modal__close');
    const overlay = modal.querySelector('.custom-modal__overlay');
    
    // Close on close button click
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        closeModal(modal);
      });
    }
    
    // Close on overlay click
    if (overlay) {
      overlay.addEventListener('click', function() {
        closeModal(modal);
      });
    }
    
    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal(modal);
      }
    });
  });
  
  function closeModal(modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }
}

function initCollapsibleFunctionality() {
  const collapsibleRows = document.querySelectorAll('.landing-featured-product__collabsible-row');
  
  collapsibleRows.forEach(row => {
    const heading = row.querySelector('.landing-featured-product__collabsible-heading');
    const icon = row.querySelector('.landing-featured-product__collabsible-icon img');
    
    if (heading) {
      heading.addEventListener('click', function() {
        row.classList.toggle('active');
        
        // Change icon based on state
        if (icon) {
          if (row.classList.contains('active')) {
            // Change to minus icon when open
            icon.src = icon.src.replace('plus-icon.svg', 'minus-icon.svg');
            icon.alt = 'Minus';
          } else {
            // Change back to plus icon when closed
            icon.src = icon.src.replace('minus-icon.svg', 'plus-icon.svg');
            icon.alt = 'Plus';
          }
        }
      });
    }
  });
}

function initTimers() {
  const timerElements = document.querySelectorAll('[data-timer]');
  
  timerElements.forEach(timerElement => {
    const buyOptionElement = timerElement.closest('.landing-featured-product__buy-option');
    if (!buyOptionElement) return;
    
    const optionId = buyOptionElement.dataset.optionId;
    if (!optionId) return;
    
    const storageKey = `timer_${optionId}`;
    
    // Get saved time or set default (10 minutes)
    let savedTime = localStorage.getItem(storageKey);
    let totalSeconds = savedTime ? parseInt(savedTime) : 600; // 10 minutes in seconds
    
    function updateTimer() {
      if (totalSeconds <= 0) {
        // Timer finished, restart
        totalSeconds = 600;
        localStorage.setItem(storageKey, totalSeconds.toString());
      }
      
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      
      const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      timerElement.textContent = timeString;
      
      totalSeconds--;
      localStorage.setItem(storageKey, totalSeconds.toString());
    }
    
    // Update timer immediately
    updateTimer();
    
    // Update timer every second
    setInterval(updateTimer, 1000);
  });
}

// Handle form submission for selected option using standard theme functionality
document.addEventListener('submit', function(e) {
  if (e.target.classList.contains('product-form')) {
    e.preventDefault();
    
    const selectedOption = document.querySelector('.landing-featured-product__buy-option.selected');
    const form = e.target;
    const button = form.querySelector('button[type="submit"]');
    
    if (selectedOption) {
      const quantityInput = form.querySelector('input[name="quantity"]');
      
      if (quantityInput) {
        const actualQuantity = selectedOption.dataset.quantity;
        quantityInput.value = actualQuantity || 1;
      }
    }
    
    // Show loading state
    if (button) {
      const buttonText = button.querySelector('.button-text');
      const originalButtonText = buttonText ? buttonText.innerHTML : button.innerHTML;
      
      button.classList.add('loading');
      button.disabled = true;
      
      // Use the same logic as standard product-form
      const formData = new FormData(form);
      
      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };
      
      fetch('/cart/add.js', config)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((parsedState) => {
          fetch('/cart.js', { method: 'GET' })
            .then(res => res.json())
            .then((cartJson) => {
              // Remove loading state immediately before any cart operations
              if (button) {
                button.classList.remove('loading');
                if (buttonText) {
                  buttonText.innerHTML = originalButtonText;
                } else {
                  button.innerHTML = originalButtonText;
                }
                button.disabled = false;
              }
              
              // Hide any loading overlays immediately
              const loadingOverlays = document.querySelectorAll('.cart-overlay, .loading-overlay, .cart-loading-overlay');
              loadingOverlays.forEach(overlay => {
                overlay.classList.remove('active', 'visible');
                overlay.style.display = 'none';
              });
              
              if (window.FoxTheme && window.FoxTheme.pubsub) {
                window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
              }
          
              if (window.FoxTheme && window.FoxTheme.cart) {
                window.FoxTheme.cart.showCartDrawer();
              }
            })
            .catch((error) => {
              console.error('Error fetching cart:', error);
              // Ensure loading state is removed even if cart fetch fails
              if (button) {
                button.classList.remove('loading');
                if (buttonText) {
                  buttonText.innerHTML = originalButtonText;
                } else {
                  button.innerHTML = originalButtonText;
                }
                button.disabled = false;
              }
              
              // Hide any loading overlays
              const loadingOverlays = document.querySelectorAll('.cart-overlay, .loading-overlay, .cart-loading-overlay');
              loadingOverlays.forEach(overlay => {
                overlay.classList.remove('active', 'visible');
                overlay.style.display = 'none';
              });
            });
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
          
          // Remove loading state
          if (button) {
            button.classList.remove('loading');
            button.disabled = false;
            if (buttonText) {
              buttonText.innerHTML = originalButtonText;
            } else {
              button.innerHTML = originalButtonText;
            }
          }
          
          // Ensure all loading overlays are hidden
          const loadingOverlays = document.querySelectorAll('.cart-overlay, .loading-overlay, .cart-loading-overlay');
          loadingOverlays.forEach(overlay => {
            overlay.classList.remove('active', 'visible');
            overlay.style.display = 'none';
          });
          
          // Ensure cart overlay/modal is closed
          if (window.FoxTheme && window.FoxTheme.cart && typeof window.FoxTheme.cart.hideCartOverlay === 'function') {
            window.FoxTheme.cart.hideCartOverlay();
          }
        });
    }
  }
});